import { BaseModel } from "../abstracts/base.model";
import { ExamAnswerModel } from './exam-answer.model';

export class ExamParticipantModel extends BaseModel {

    ExamParticipantID
    ExamID
    TermID
    ExamBookletID
    StudentID
    NumberOfCorrectAnswer
    NumberOfWrongAnswer
    NumberOfBlankAnswer
    TotalMark
    StartDate: Date
    EndDate: Date
    StatusID: number;
  
    LastDuration: number;
    StatusDescription:string;
    ExamParticipantAnswers: ExamAnswerModel[]
}
